import { render } from "./package-input-fields.vue?vue&type=template&id=d53f8074"
import script from "./package-input-fields.vue?vue&type=script&lang=js"
export * from "./package-input-fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__